(()=> {
    let scroll_pos = window.pageYOffset || window.scrollY,
        status = false;
    
    let down,
        lastScrollTop = 0;

    const action = function() {   
        let st = window.pageYOffset || document.documentElement.scrollTop;
       
        if (st > lastScrollTop){
           down = true;
        } else {
            down = false;
        }

        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
            
        if (down === true) {
            if (status === false) {
                //el.classList.add('is-out');
                document.documentElement.classList.remove('scroll-up');
                status = true;
            }
        } else {
            if (status === true) {
                document.documentElement.classList.add('scroll-up');
                //el.classList.remove('is-out');
                status = false;
            }
        }
    }

    window.addEventListener('scroll', action);    
})();
